import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-general-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  templateUrl: './general-modal.component.html',
  styleUrl: './general-modal.component.scss'
})
export class GeneralModalComponent implements OnInit {
  @Input('modalId') modalId: string;
  // @Input() dynamicHtml: string;
  private _dynamicHtml: string;
  @Input('closeModalFn') closeModalFn: any;
  @Input() modalSize: string; // Add this input property
  @ViewChild('modalContent') modalContent: ElementRef;
  safeHtml: SafeHtml;

  // @ts-ignore
  @Input()
  // @ts-ignore
  set dynamicHtml(html: string) {
    this._dynamicHtml = html;
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(html);
  }

  // @ts-ignore
  get dynamicHtml(): string {
    return this._dynamicHtml;
  }

  constructor(private loader: GlobalLoaderService,
              private sanitizer: DomSanitizer,
              private translate: TranslateService) {
  }

  async ngOnInit() {
    await this.loader.loadExternalScript('https://kit.fontawesome.com/7cc96e74fa.js');
  }

  closeModal() {
    if (this.closeModalFn) {
      this.closeModalFn();
    }

    $(`#${this.modalId}`).modal('hide');
  }
}
